module.exports = __webpack_public_path__ + "img/area-limit-btn-disabled.0331d65a.png";